import _ from '@lodash';
import * as yup from 'yup';
import { useEffect, useState } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useWorkflow } from '../../WorkflowProvider';
import ReformerConversion from './ReformerConversion';
import ReformerSelectivityStoichiometry from './ReformerSelectivityStoichiometry';
import ReformerProvider, { useReformer } from './ReformerProvider';
import { TransComponentTitleField, TransFeatureColumnField, TransInputKeyField, TransNameField, TransOutputKeyField, TransValidationIOKey, TransValidationName } from '../TransformationProperties';
import TransformationPropertiesDialog from '../TransformationPropertiesDialog';
import { converter } from './ReformerTransformation';

function ReformerProperties() {
	const { data, showPropertiesDialog, transformationNameAvailable } = useWorkflow();
	const { t } = useTranslation(['transformer', 'validation']);
	const item = data.transform.find(d => d.key === showPropertiesDialog.key);
	const [tabValue, setTabValue] = useState(0);
	const { grid, setGrid } = useReformer();

	useEffect(() => {
		if (item)
			setGrid({
				rows: item.rows,
				columns: item.columns,
				conversion: item.conversion,
				selectivity: item.selectivity,
				stoichiometry: item.stoichiometry
			});
	}, [item]);

	const schema = yup.object().shape({
		name: TransValidationName(transformationNameAvailable, item.key),
		input_fields: TransValidationIOKey(),
		output_fields: TransValidationIOKey()
	});

	const handleTabChange = (event, value) => {
		setTabValue(value);
	};

	return (
		<TransformationPropertiesDialog
			maxWidth="lg"
			schema={schema}
			titleKey="reformerProperties"
			converter={converter}
			titleContent={
				<Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto" classes={{ root: 'h-64 bg-white' }}>
					<Tab className="h-64" label={t('basicInfo')} />
					<Tab className="h-64" label={t('conversion')} />
					<Tab className="h-64" label={t('selectivity')} />
					<Tab className="h-64" label={t('stoichiometry')} />
				</Tabs>
			}
			mergeValue={value => {
				return { ...value, ...grid };
			}}
			mergeProcess={(value, def) => {
				const result = { ...value, ...def };
				result.conversion = value.conversion;
				result.selectivity = value.selectivity;
				result.stoichiometry = value.stoichiometry;
				return result;
			}}
		>
			<div className={tabValue !== 0 ? 'hidden' : 'mt-16'}>
				<TransNameField />
				<TransInputKeyField />
				<TransOutputKeyField />
				<TransFeatureColumnField />
				<TransComponentTitleField />
			</div>
			<div className={tabValue !== 1 ? 'hidden' : 'mt-16'}>{tabValue === 1 && <ReformerConversion />}</div>
			<div className={tabValue !== 2 ? 'hidden' : 'mt-16'}>{tabValue === 2 && <ReformerSelectivityStoichiometry type="selectivity" />}</div>
			<div className={tabValue !== 3 ? 'hidden' : 'mt-16'}>{tabValue === 3 && <ReformerSelectivityStoichiometry type="stoichiometry" />}</div>
		</TransformationPropertiesDialog>
	);
}

export default function () {
	return (
		<ReformerProvider>
			<ReformerProperties />
		</ReformerProvider>
	);
}
